import Button from "../../atoms/Button";
import classnames from "classnames";
import "./styles.scss";

const BlogSection = (props) => {
  const BlogSectionClassNames = classnames("BlogSection", {
    "BlogSection--mobileColumns": props.mobileColumns,
  });

  return (
    <div
      className={`${BlogSectionClassNames} BlogSection--${props.type} BlogSection--${props.className}`}>
      {props.featurePost && (
        <div className="BlogSection__featurePost">
          <img
            src={props.featurePost.featureImage}
            className="BlogSection__postImage"
            alt={props.featurePost.title}
          />
          <h3 className="BlogSection__featurePostTitle">{props.featurePost.title}</h3>
          <div
            className="BlogSection__featurePostExcept"
            dangerouslySetInnerHTML={{
              __html: `${props.featurePost.except.substring(0, 605)}...</p>`,
            }}></div>
          <div className="BlogSection__featurePostButton">
            <Button
              primary
              full
              label="Read more"
              link={`/blog/${props.featurePost.path}`}
              dataQa="landing-home-test"
            />
          </div>
        </div>
      )}
      <div className="BlogSection__postList">
        {props.posts.map(function (post, index) {
          return (
            <div
              className="BlogSection__post"
              key={`post-${index}`}>
              <img
                src={post.featureImage}
                className="BlogSection__postImage"
                alt={post.title}
              />
              <h3 className="BlogSection__postTitle">{post.title}</h3>
              <div
                className="BlogSection__postExcept"
                dangerouslySetInnerHTML={{
                  __html: `${post.except.substring(0, 117)}...</p>`,
                }}></div>
              <div className="BlogSection__postButton">
                <Button
                  primary
                  full
                  label="Read more"
                  link={`/blog/${post.path}`}
                  dataQa="landing-home-test"
                />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default BlogSection;
